(() => {
  class RemoveItem extends HTMLElement {
    connectedCallback() {
      const deleteBtn = this.querySelector("button");
      deleteBtn.addEventListener("click", () => {
        const eventDelete = new CustomEvent("deleteLineItem", {
          bubbles: true,
          detail:{
            state : {
              id: deleteBtn.getAttribute("data-line-item"),
              quantity: 0,
              hasCorrectQuantity: true,
              message: "",
            }
          }
        });
        deleteBtn.dispatchEvent(eventDelete);
      });
    }
  }
  if (!customElements.get("remove-line-item")) {
    customElements.define("remove-line-item", RemoveItem);
  }
})();
